import styled from "styled-components";
import { Button as BaseButton } from "../components/Button";

export const FormSubmitButton = styled(BaseButton)`
  width: 100%;
  font-size: 24px;
  line-height: 40px;
  margin-top: 19px;
`;
